module.exports = __webpack_public_path__ + "static/pl-hero-background-crop-wide-26aaee0417d3fe60880da3c8bcdb854b.jpg";